import { render, staticRenderFns } from "./updateStatus.vue?vue&type=template&id=16e000fd&scoped=true"
import script from "./updateStatus.vue?vue&type=script&lang=js"
export * from "./updateStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e000fd",
  null
  
)

export default component.exports